// Module
var code = "\n<div class=\"vn-progressbar\">\n  <div class=\"infoWrapper\" style=\"margin-left: {{form.value}}%\"><span class=\"info\">{{ form.value  | number:0 }}%</span></div>\n  <div class=\"progress\"><span class=\"meter {{form.barClasses}}\" style=\"width: {{form.value}}%;\"></span></div>\n</div>";
// Exports
export default code;